"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ToggleSwitchV2", {
  enumerable: true,
  get: function get() {
    return _ToggleSwitch["default"];
  }
});
var _ToggleSwitch = _interopRequireDefault(require("./ToggleSwitch"));